/* Completezza dei dati scatola di un articolo venduto a mq/ml.
   Senza mq/scatola (o ml/confezione) e pz/scatola il preventivo non è
   trasformabile in ordine: le scatole da ordinare e i pezzi da movimentare
   non sono derivabili dalla quantità in mq. L'operatore può comunque
   preventivare, ma la scheda va completata prima di confermare al cliente. */

const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
};

export function itemCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

const isPositive = (v) => Number(v) > 0;

/* mq/ml effettivi per scatola dell'articolo: 0 se l'articolo non è venduto a
   scatola o se il dato manca. Con 0 le scatole non sono calcolabili, quindi
   giacenza e quantità da ordinare non vanno mostrate. */
export function itemPerBox(item) {
  const group = itemCategoryGroup(item?.category);
  if (group === "linear") return Number(item?.mlPerBox) || 0;
  if (group === "area") return Number(item?.sqmPerBox) || 0;
  return 0;
}

/* Campi scatola mancanti, con le etichette del form articolo.
   N° scatole è la giacenza: si segnala ma non blocca la conferma. */
export function missingStockFields(item) {
  const group = itemCategoryGroup(item?.category);
  if (group !== "area" && group !== "linear") return [];

  // un campo assente dalla risposta API (undefined) non è un campo vuoto:
  // si giudica solo quello che è stato effettivamente caricato
  const known = (v) => v !== undefined;

  const missing = [];
  if (group === "linear") {
    if (known(item?.mlPerBox) && !isPositive(item?.mlPerBox)) {
      missing.push("ML / confezione");
    }
  } else if (known(item?.sqmPerBox) && !isPositive(item?.sqmPerBox)) {
    missing.push("M² / scatola");
  }
  if (known(item?.piecesPerBox) && !isPositive(item?.piecesPerBox)) {
    missing.push("Pz / scatola");
  }
  // N° scatole vive sul magazzino (warehouse.boxQuantity), non sull'articolo:
  // se il magazzino non è stato caricato il dato non si può giudicare
  const boxes = item?.warehouse?.boxQuantity ?? item?.boxQuantity;
  if (known(boxes) && !isPositive(boxes))
    missing.push("N° scatole (da Magazzino)");
  return missing;
}

/* True se manca un dato strutturale (mq/ml per scatola o pz/scatola): il
   preventivo resta salvabile ma non confermabile. */
export function hasIncompleteStockData(item) {
  const missing = missingStockFields(item);
  return missing.some((f) => !f.startsWith("N° scatole"));
}

/* Etichetta dell'articolo da mostrare negli avvisi */
export function itemStockLabel(item) {
  return (
    item?.itemName ||
    item?.subBrand ||
    item?.brand ||
    item?.supplierCode ||
    item?.itemCode ||
    "—"
  );
}
